<template>
    <div class="PresetsContainer">
        <div class="PresetsHeader">
            <WIcon
                icon="heart"
                color="accent-blue"
                :size="12"
            />
            <WText
                color="accent-blue"
                weight="bold"
                :size="14"
                class="PresetsTitle"
            >
                {{ $t('filters.presets.title') }}
            </WText>
        </div>
        <div class="PresetsActionableWrapper">
            <div class="PresetsSelectWrapper">
                <WSelect
                    class="PresetsSelect"
                    name="presetSelect"
                    :value="selectedPreset"
                    :placeholder="$t('filters.presets.placeholder')"
                    :options="presetsOptions"
                    @input="handlePresetChange"
                />
                <WButton
                    iconLeft="check"
                    color="accent-blue"
                    :disabled="applyDisabled"
                    @click="applyPreset"
                />
            </div>
            <div class="PresetsButtons">
                <WButton
                    :class="{ invisible: !selectedPreset }"
                    color="accent-blue"
                    iconLeft="trash"
                    :iconSize="14"
                    size="sm"
                    :disabled="!selectedPreset"
                    @click="deleteOpen = true"
                >
                    {{ $t('filters.presets.delete.action') }}
                </WButton>
                <WButton
                    :class="{ invisible: !selectedPreset }"
                    color="accent-blue"
                    iconLeft="edit"
                    :iconSize="14"
                    size="sm"
                    :disabled="!selectedPreset"
                    @click="editNameOpen = true"
                >
                    {{ $t('filters.presets.edit.action') }}
                </WButton>
            </div>
        </div>
        <DeletePresetModal
            :isOpen="deleteOpen"
            :selectedPreset="getSelectedPreset()"
            @refreshPresets="refreshPresets"
            @close="deleteOpen = false"
        />
        <SavePresetModal
            type="edit"
            :isOpen="editNameOpen"
            :selectedPreset="getSelectedPreset()"
            :presetsOptions="presetsOptions"
            @nameEdited="nameEdited"
            @close="editNameOpen = false"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { mapGetters } from 'vuex'
import { isEqual } from 'lodash'
import DeletePresetModal from './DeletePresetModal.vue'
import SavePresetModal from './SavePresetModal.vue'

export default {
    name: 'PresetsSearches',
    components: { DeletePresetModal, SavePresetModal },
    props: {
        presetsOptions: VueTypes.array,
    },
    data () {
        return {
            selectedPreset: '',
            deleteOpen: false,
            editNameOpen: false,
        }
    },
    computed: {
        ...mapGetters({
            relatedFilters: 'filters/relatedFilters',
        }),
        applyDisabled () {
            const { selectedPreset, relatedFilters, getSelectedPreset } = this
            return !selectedPreset || isEqual(relatedFilters, getSelectedPreset()?.data?.related)
        },
    },
    methods: {
        handlePresetChange (value) {
            this.selectedPreset = value
        },
        getSelectedPreset () {
            return this.presetsOptions.find(o => o.key === this.selectedPreset)
        },
        applyPreset () {
            this.$emit('applyPreset', this.getSelectedPreset()?.data?.related)
        },
        refreshPresets () {
            this.handlePresetChange('')
            this.$emit('refreshPresets')
        },
        nameEdited (id) {
            this.$emit('nameEdited', id)
        },
    },
}
</script>

<style lang="scss" scoped>
.PresetsContainer {
    width: 18%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-right: 15px;
    margin: 15px 0 15px 15px;
    border-right: 1px solid $gray-04;
    .PresetsHeader {
        display: flex;
        align-items: center;
        margin-left: 15px;
        .PresetsTitle {
            margin: 3px 0 0 6px;
        }
    }
    .PresetsActionableWrapper {
        display: flex;
        flex-direction: column;
        gap: 2px;
        .PresetsSelectWrapper {
            display: flex;
            flex-direction: row;
            gap: 6px;
            .PresetsSelect {
                display: flex;
                flex: 1;
            }
        }
        .PresetsButtons {
            display: flex;
            flex-direction: row;
            .invisible {
                visibility: hidden;
                opacity: 0;
            }
        }
    }
}
</style>
